import axios from '@/utils/axios';

interface AuthenticatePayload {
  shop_name: string;
  merchant_id: string;
  success_redirect_url: string;
}

const shopifyUpdaters = {
  authenticate: async (payload: AuthenticatePayload) => {
    return axios.post('/shopify/authenticate', payload);
  },
};

export default shopifyUpdaters;
